<template>
  <CommonLayout>
    <div class="profile-content">
      <el-card>
        <template #header>
          <div class="card-header">
            <!-- 新增图标 -->
            <el-icon><User /></el-icon> 
            <!-- 新增表单标题 -->
            <span>个人信息</span>
          </div>
        </template>
        <div class="card-content">
          <el-form
            ref="profileFormRef"
            :model="profileForm"
            :rules="profileRules"
            label-width="120px"
          >
            <!-- 显示手机号 -->
            <el-form-item label="手机号">
              <span>{{ userInfo ? userInfo.username : '' }}</span>
            </el-form-item>
            <!-- 移动邮箱字段到此处，以显示方式呈现 -->
            <el-form-item label="邮箱">
              <span>{{ userInfo ? userInfo.email : '' }}</span>
            </el-form-item>
            <!-- 新增角色显示 -->
            <el-form-item label="角色">
              <span>{{ userInfo && userInfo.roleId === 1 ? '管理员' : '普通用户' }}</span>
            </el-form-item>
            <el-form-item label="昵称" prop="nickName">
              <!-- 昵称改为输入框 -->
              <el-input v-model="profileForm.nickName"></el-input>
            </el-form-item>
            <!-- 删除原邮箱输入框 -->
            <!--
<｜placeholder｜>
          <el-input v-model="profileForm.email"></el-input>
<｜placeholder｜>
        -->
            <el-form-item label="密码" prop="password">
              <el-input v-model="profileForm.password" type="password" placeholder="不修改则无需填写"></el-input>
            </el-form-item>
            <el-form-item label="确认密码" prop="confirmPassword">
              <el-input v-model="profileForm.confirmPassword" type="password" placeholder="不修改则无需填写"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="saveProfile">保存</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-card>
    </div>
  </CommonLayout>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import CommonLayout from '@/components/CommonLayout.vue'
import { ElMessage } from 'element-plus'
import { generateTimestamp, generateToken, encryptPassword } from '@/utils/crypto' // 引入 encryptPassword 方法
import { API_PATHS } from '@/config/api'
import { useRouter } from 'vue-router'
import service from '@/utils/http'
// 引入图标
import { User } from '@element-plus/icons-vue' 

const router = useRouter()
const profileFormRef = ref(null) // 定义表单引用

const profileForm = ref({
  username: '', // 保留手机号，在请求接口时使用
  nickName: '',
  // 删除邮箱字段
  password: '',
  confirmPassword: ''
})

const userInfoStr = localStorage.getItem('userInfo')
const userInfo = userInfoStr ? JSON.parse(userInfoStr) : null
const userId = ref(userInfo ? userInfo.userId : null)

// 定义密码规则
const profileRules = {
  password: [
    // 修改部分：移除 required 规则
    { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
  ],
  confirmPassword: [
    {
      validator: (rule, value, callback) => {
        if (profileForm.value.password) {
          // 只有当密码不为空时才验证确认密码
          if (value !== profileForm.value.password) {
            callback(new Error('两次输入密码不一致'));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      trigger: 'blur'
    }
  ],
  // 修改部分：添加与Auth.vue一致的昵称规则
  nickName: [
    { required: true, message: '请输入昵称', trigger: 'blur' },
    { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' }
  ]
  // 修改部分结束
}

const saveProfile = async () => {
  if (!profileFormRef.value) return
  await profileFormRef.value.validate(async (valid) => {
    if (valid) {
      if (profileForm.value.password !== profileForm.value.confirmPassword) {
        ElMessage.error('两次输入的密码不一致，请重新输入。')
        return
      }

      const timestamp = generateTimestamp()

      // 从 userInfo 中获取手机号
      const phoneNumber = userInfo ? userInfo.username : ''

      let encryptedPassword = null
      if (profileForm.value.password) {
        encryptedPassword = encryptPassword(generatePwd(phoneNumber, profileForm.value.password)) // 使用 encryptPassword 方法加密密码
      }
      const params = {
        userId: userId.value,
        username: phoneNumber,
        password: encryptedPassword,
        nickName: profileForm.value.nickName,
        // 删除邮箱字段
        timestamp
      }

      // 修改部分：根据 password 是否为空决定是否加入 token 加密
      let tokenParams = {
        userId: userId.value,
        username: phoneNumber,
        nickName: profileForm.value.nickName,
        // 删除邮箱字段
        timestamp
      }
      if (encryptedPassword) {
        tokenParams.password = encryptedPassword // 使用加密后的密码参与 token 加密
      }
      params.token = generateToken(tokenParams)
      // 修改部分结束

      try {
        await service.post(`${API_PATHS.editUser}`, params)
        ElMessage.success('保存成功')
        setTimeout(() => {
          localStorage.removeItem('userInfo') // 清除用户缓存
          // 修改部分：跳转到 /auth 页面
          router.push('/auth')
        }, 2000)
      } catch (error) {
        ElMessage.error(error.message || '保存失败')
      }
    }
  })
}

const generatePwd = (username, password) => {
  return `${username}${password}FOS`
}

onMounted(() => {
  if (userInfo) {
    // 不再给 profileForm.value.username 赋值
    profileForm.value.nickName = userInfo.nickName
    // 删除邮箱赋值
  }
})
</script>

<style scoped>
.profile-content {
  padding: 20px;
}

.card-header {
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 500;
}

.card-content {
  padding: 20px;
  background-color: #fff;
  border-radius: 4px;
}
</style>